<template>
  <Popover
    v-slot="{ open }: { open: boolean }"
    as="div"
  >
    <PopoverButton
      :class="open ? 'border-gray-300 bg-gray-100' : 'border-transparent hover:bg-gray-100'"
      class="wc-focus flex size-12 items-center justify-center rounded-full border-t focus-visible:underline-offset-1"
      data-test-id="site-search-button"
      @click="handlePopoverClick"
      @keydown.enter="handlePopoverClick"
    >
      <span
        class="sr-only"
        v-text="open ? 'Close Search Menu' : 'Open Search Menu'"
      />
      <IconSearch
        :size="24"
        aria-hidden="true"
        class="text-gray-800"
      />
    </PopoverButton>
    <Transition
      enter-active-class="transition-transform duration-300 ease-out motion-reduce:hover:transform-none"
      enter-from-class="-translate-y-full md:-translate-y-1"
      enter-to-class="translate-y-0 md:opacity-100"
      leave-active-class="transition-transform duration-200 ease-in motion-reduce:hover:transform-none"
      leave-from-class="translate-y-0 md:opacity-100"
      leave-to-class="-translate-y-full md:translate-y-1"
    >
      <PopoverPanel
        v-slot="{ close }"
        as="div"
        class="absolute top-0 z-10 w-full max-w-xl rounded-b-2xl bg-white p-4 shadow-sm max-lg:left-0 md:top-full md:mt-px md:pr-12 lg:right-0"
      >
        <div class="flex items-center gap-x-4">
          <div class="relative w-full rounded-full">
            <label
              class="sr-only"
              for="site-search-input"
              v-text="'Search This Site'"
            />
            <input
              id="site-search-input"
              v-model.trim="searchTerm"
              class="rounded-full border-gray-100 bg-gray-100"
              placeholder="Search"
              type="text"
              @keydown.enter.prevent="handleSearch"
            >
            <div class="cursor-pointer absolute inset-y-0 right-0 flex items-center pr-3.5">
              <IconSearch
                :size="24"
                aria-hidden="true"
                class="text-gray-800"
                @click="handleSearch"
              />
            </div>
          </div>

          <button
            class="wc-focus"
            type="button"
            @click="close"
          >
            <span
              class="sr-only"
              v-text="'Close Search Menu'"
            />
            <IconX
              :size="24"
              aria-hidden="true"
              class="text-gray-800"
            />
          </button>
        </div>
      </PopoverPanel>
    </Transition>
  </Popover>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { IconSearch, IconX } from '@tabler/icons-vue'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'

import { env } from '@js/utils/env'
import { usePopover } from '@js/composables/usePopover'

defineOptions({
  name: 'AppSiteSearch',
})

const { handlePopoverClick } = usePopover()

const searchTerm = ref('')

const indexName = computed(() => env.elasticsearch.SEARCH_INDEX)

const handleSearch = (): void => {
  if (searchTerm.value) {
    const encodedURL = encodeURI(`${indexName.value}[query]=${searchTerm.value}`)

    window.location.assign(`/search?${encodedURL}`)
  }
}
</script>
